export type EventStatusKey = 'Active' | 'Removal' | 'Hidden' | 'Closed' | 'TBD' | string;

export interface EventStatusDetails {
  label: string;
  isActive: boolean;
  isHidden: boolean;
  isRemoved: boolean;
}

const normalizeStatus = (value?: string | null) => String(value || '').trim().toLowerCase();

export const getEventSyncPayload = (isActive: boolean) => ({
  e_is_active: isActive,
  e_status: isActive ? 'Active' : 'Removal',
});

export const getEventStatusDetails = (event: { e_status?: string | null; e_is_active?: boolean | null }): EventStatusDetails => {
  const rawStatus = normalizeStatus(event?.e_status);
  const isActiveFlag = event?.e_is_active === true;

  if (rawStatus === 'removal') {
    return { label: 'Hidden', isActive: false, isHidden: true, isRemoved: true };
  }


  if (rawStatus === 'hidden') {
    return { label: 'Hidden', isActive: false, isHidden: true, isRemoved: false };
  }

  if (rawStatus === 'active') {
    return { label: 'Active', isActive: true, isHidden: false, isRemoved: false };
  }

  if (rawStatus === 'closed') {
    return { label: 'Closed', isActive: false, isHidden: false, isRemoved: false };
  }

  if (rawStatus === 'tbd') {
    return { label: 'TBD', isActive: false, isHidden: false, isRemoved: false };
  }

  return {
    label: isActiveFlag ? 'Active' : 'Hidden',
    isActive: isActiveFlag,
    isHidden: !isActiveFlag,
    isRemoved: false,
  };
};
